import { Link } from "react-router-dom";
import { ArrowRight, BadgeCheck } from "lucide-react";
import { api, photoUrl } from "../../lib/api";

const PromoBtn = ({ label, link, style, className, testid, onClick }) => {
  const inner = <>{label} <ArrowRight size={17} /></>;
  const cls = `inline-flex items-center justify-center gap-2 h-12 px-7 rounded-xl font-semibold text-sm sm:text-base transition-[filter,transform] hover:brightness-110 active:scale-[0.98] ${className}`;
  return link.startsWith("/") && !link.startsWith("//")
    ? <Link to={link} style={style} className={cls} data-testid={testid} onClick={onClick}>{inner}</Link>
    : <a href={link} target="_blank" rel="noopener noreferrer" style={style} className={cls} data-testid={testid} onClick={onClick}>{inner}</a>;
};

// mode: "auto" uses phone height below 640px; "mobile"/"desktop" force one (admin preview).
export const VerifyPromo = ({ s, lang, variant = "a", mode = "auto", onCtaClick }) => {
  const fr = lang === "fr";
  const pick = (k) => (fr && s[`${k}_fr`]) || s[`${k}_en`] || "";
  const titleB = pick("title_b");
  const title = variant === "b" && titleB ? titleB : pick("title");
  const center = s.align === "center";
  const b1 = pick("btn1"), b2 = pick("btn2");
  const hm = `${s.height_mobile}px`, hd = `${s.height_desktop}px`;
  const minH = mode === "mobile" ? "min-h-[var(--hm)]" : mode === "desktop" ? "min-h-[var(--hd)]" : "min-h-[var(--hm)] sm:min-h-[var(--hd)]";
  const row = mode === "mobile" ? "flex-col" : mode === "desktop" ? "flex-row items-center" : "flex-col lg:flex-row lg:items-center";
  return (
    <div className={`relative overflow-hidden rounded-3xl px-6 sm:px-10 py-10 flex items-center ${minH}`}
      style={{ background: s.bg_color, color: s.text_color, "--hm": hm, "--hd": hd }} data-testid="verify-promo-box">
      {s.bg_image && (
        <>
          <img src={photoUrl(s.bg_image)} alt="" className="absolute inset-0 w-full h-full object-cover" data-testid="verify-promo-bg" />
          <div className="absolute inset-0" style={{ background: s.bg_color, opacity: s.overlay / 100 }} />
        </>
      )}
      {s.glow && <div className="absolute -top-16 -right-16 h-64 w-64 rounded-full blur-3xl opacity-20" style={{ background: s.accent_color }} />}
      <div className={`relative w-full flex gap-6 lg:gap-10 ${center ? "flex-col items-center text-center" : row}`}>
        <div className={`flex-1 ${center ? "flex flex-col items-center" : ""}`}>
          {pick("badge") && (
            <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest rounded-full px-3 py-1 backdrop-blur" style={{ background: "rgba(255,255,255,0.12)" }} data-testid="verify-promo-badge">
              <BadgeCheck size={13} style={{ color: s.accent_color }} /> {pick("badge")}
            </span>
          )}
          {title && <h2 className="font-display font-extrabold text-2xl sm:text-3xl lg:text-4xl mt-4 tracking-tight" data-testid="home-verify-headline">{title}</h2>}
          {pick("body") && <p className={`mt-3 max-w-xl text-sm sm:text-base leading-relaxed opacity-85 whitespace-pre-line ${center ? "mx-auto" : ""}`} data-testid="verify-promo-body">{pick("body")}</p>}
        </div>
        {(b1 || b2) && (
          <div className={`flex flex-wrap gap-3 shrink-0 ${center ? "justify-center" : ""}`}>
            {b1 && s.btn1_link && <PromoBtn label={b1} link={s.btn1_link} style={{ background: s.btn1_bg, color: s.btn1_text }} testid="home-get-verified-cta" onClick={onCtaClick} />}
            {b2 && s.btn2_link && <PromoBtn label={b2} link={s.btn2_link} style={{ color: s.text_color, borderColor: s.text_color }} className="border-2 bg-transparent" testid="home-verify-btn2" />}
          </div>
        )}
      </div>
    </div>
  );
};

export const trackPromoClick = (variant) => api.post("/site/verify-promo/click", { variant }).catch(() => {});
